
import { defineComponent } from "vue";
import { footerWidthFluid } from "@/core/helpers/config";

export default defineComponent({
  name: "KTFooter",
  setup() {
    return {
      footerWidthFluid,
    };
  },

  methods: {
    currentYearDate() {
      const current = new Date();
      const date = `${current.getFullYear()}`;
      return date;
    },
  },
});
